import * as Types from '../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateFaxMutationVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
  e164?: Types.InputMaybe<Types.Scalars['String']['input']>;
  shortNumber: Types.Scalars['String']['input'];
  outgoingCallBarringOperator?: Types.InputMaybe<Array<Types.InputMaybe<Types.OutgoingCallBarring>>>;
  outgoingCallBarringAdmin?: Types.InputMaybe<Array<Types.InputMaybe<Types.OutgoingCallBarring>>>;
  incomingEmailAddress: Types.Scalars['String']['input'];
  senderEmailAddress?: Types.InputMaybe<Types.Scalars['String']['input']>;
  password: Types.Scalars['String']['input'];
  notifyUnsuccessfulReceiving: Types.Scalars['Boolean']['input'];
  additionalFaxSendingEmails: Array<Types.InputMaybe<Types.Scalars['String']['input']>>;
}>;


export type CreateFaxMutation = { __typename?: 'Mutation', createFax?: { __typename?: 'SaveResult', id?: number | null, errors?: Array<{ __typename?: 'Error', location: Array<string>, context?: string | null, type: string }> | null } | null };

export type DeleteFaxMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
  relatedData: Types.FaxRetargets;
}>;


export type DeleteFaxMutation = { __typename?: 'Mutation', deleteFax?: { __typename?: 'MutationResult', errors?: Array<{ __typename?: 'Error', location: Array<string>, context?: string | null, type: string }> | null } | null };

export type UpdateFaxMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
  outgoingCallBarringAdmin?: Types.InputMaybe<Array<Types.InputMaybe<Types.OutgoingCallBarring>>>;
  outgoingCallBarringOperator?: Types.InputMaybe<Array<Types.InputMaybe<Types.OutgoingCallBarring>>>;
  nonPaymentBlockingType?: Types.InputMaybe<Types.NonPaymentBlockingType>;
  headerInfo?: Types.InputMaybe<Types.Scalars['String']['input']>;
  headerNumber: Types.Scalars['String']['input'];
  incomingEmailAddress: Types.Scalars['String']['input'];
  senderEmailAddress?: Types.InputMaybe<Types.Scalars['String']['input']>;
  password: Types.Scalars['String']['input'];
  notifyUnsuccessfulReceiving: Types.Scalars['Boolean']['input'];
  additionalFaxSendingEmails: Types.AdditionalFaxSendingEmails;
}>;


export type UpdateFaxMutation = { __typename?: 'Mutation', updateFax?: { __typename?: 'MutationResult', errors?: Array<{ __typename?: 'Error', location: Array<string>, context?: string | null, type: string }> | null } | null };

export type SynchronizeFaxMutationVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type SynchronizeFaxMutation = { __typename?: 'Mutation', synchronizeFax?: { __typename?: 'SynchronizeFaxResult', created?: number | null, updated?: number | null, deleted?: number | null, errors?: Array<{ __typename?: 'Error', location: Array<string>, context?: string | null, type: string }> | null } | null };


export const CreateFaxDocument = gql`
    mutation CreateFax($domainId: Int!, $e164: String, $shortNumber: String!, $outgoingCallBarringOperator: [OutgoingCallBarring], $outgoingCallBarringAdmin: [OutgoingCallBarring], $incomingEmailAddress: String!, $senderEmailAddress: String, $password: String!, $notifyUnsuccessfulReceiving: Boolean!, $additionalFaxSendingEmails: [String]!) {
  createFax(
    domainId: $domainId
    e164: $e164
    shortNumber: $shortNumber
    outgoingCallBarringOperator: $outgoingCallBarringOperator
    outgoingCallBarringAdmin: $outgoingCallBarringAdmin
    incomingEmailAddress: $incomingEmailAddress
    senderEmailAddress: $senderEmailAddress
    password: $password
    notifyUnsuccessfulReceiving: $notifyUnsuccessfulReceiving
    additionalFaxSendingEmails: $additionalFaxSendingEmails
  ) {
    id
    errors {
      location
      context
      type
    }
  }
}
    `;
export type CreateFaxMutationFn = Apollo.MutationFunction<CreateFaxMutation, CreateFaxMutationVariables>;

/**
 * __useCreateFaxMutation__
 *
 * To run a mutation, you first call `useCreateFaxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFaxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFaxMutation, { data, loading, error }] = useCreateFaxMutation({
 *   variables: {
 *      domainId: // value for 'domainId'
 *      e164: // value for 'e164'
 *      shortNumber: // value for 'shortNumber'
 *      outgoingCallBarringOperator: // value for 'outgoingCallBarringOperator'
 *      outgoingCallBarringAdmin: // value for 'outgoingCallBarringAdmin'
 *      incomingEmailAddress: // value for 'incomingEmailAddress'
 *      senderEmailAddress: // value for 'senderEmailAddress'
 *      password: // value for 'password'
 *      notifyUnsuccessfulReceiving: // value for 'notifyUnsuccessfulReceiving'
 *      additionalFaxSendingEmails: // value for 'additionalFaxSendingEmails'
 *   },
 * });
 */
export function useCreateFaxMutation(baseOptions?: Apollo.MutationHookOptions<CreateFaxMutation, CreateFaxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFaxMutation, CreateFaxMutationVariables>(CreateFaxDocument, options);
      }
export type CreateFaxMutationHookResult = ReturnType<typeof useCreateFaxMutation>;
export type CreateFaxMutationResult = Apollo.MutationResult<CreateFaxMutation>;
export type CreateFaxMutationOptions = Apollo.BaseMutationOptions<CreateFaxMutation, CreateFaxMutationVariables>;
export const DeleteFaxDocument = gql`
    mutation DeleteFax($id: Int!, $relatedData: FaxRetargets!) {
  deleteFax(id: $id, relatedData: $relatedData) {
    errors {
      location
      context
      type
    }
  }
}
    `;
export type DeleteFaxMutationFn = Apollo.MutationFunction<DeleteFaxMutation, DeleteFaxMutationVariables>;

/**
 * __useDeleteFaxMutation__
 *
 * To run a mutation, you first call `useDeleteFaxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFaxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFaxMutation, { data, loading, error }] = useDeleteFaxMutation({
 *   variables: {
 *      id: // value for 'id'
 *      relatedData: // value for 'relatedData'
 *   },
 * });
 */
export function useDeleteFaxMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFaxMutation, DeleteFaxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFaxMutation, DeleteFaxMutationVariables>(DeleteFaxDocument, options);
      }
export type DeleteFaxMutationHookResult = ReturnType<typeof useDeleteFaxMutation>;
export type DeleteFaxMutationResult = Apollo.MutationResult<DeleteFaxMutation>;
export type DeleteFaxMutationOptions = Apollo.BaseMutationOptions<DeleteFaxMutation, DeleteFaxMutationVariables>;
export const UpdateFaxDocument = gql`
    mutation UpdateFax($id: Int!, $outgoingCallBarringAdmin: [OutgoingCallBarring], $outgoingCallBarringOperator: [OutgoingCallBarring], $nonPaymentBlockingType: NonPaymentBlockingType, $headerInfo: String, $headerNumber: String!, $incomingEmailAddress: String!, $senderEmailAddress: String, $password: String!, $notifyUnsuccessfulReceiving: Boolean!, $additionalFaxSendingEmails: AdditionalFaxSendingEmails!) {
  updateFax(
    id: $id
    outgoingCallBarringAdmin: $outgoingCallBarringAdmin
    outgoingCallBarringOperator: $outgoingCallBarringOperator
    nonPaymentBlockingType: $nonPaymentBlockingType
    headerInfo: $headerInfo
    headerNumber: $headerNumber
    incomingEmailAddress: $incomingEmailAddress
    senderEmailAddress: $senderEmailAddress
    password: $password
    notifyUnsuccessfulReceiving: $notifyUnsuccessfulReceiving
    additionalFaxSendingEmails: $additionalFaxSendingEmails
  ) {
    errors {
      location
      context
      type
    }
  }
}
    `;
export type UpdateFaxMutationFn = Apollo.MutationFunction<UpdateFaxMutation, UpdateFaxMutationVariables>;

/**
 * __useUpdateFaxMutation__
 *
 * To run a mutation, you first call `useUpdateFaxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFaxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFaxMutation, { data, loading, error }] = useUpdateFaxMutation({
 *   variables: {
 *      id: // value for 'id'
 *      outgoingCallBarringAdmin: // value for 'outgoingCallBarringAdmin'
 *      outgoingCallBarringOperator: // value for 'outgoingCallBarringOperator'
 *      nonPaymentBlockingType: // value for 'nonPaymentBlockingType'
 *      headerInfo: // value for 'headerInfo'
 *      headerNumber: // value for 'headerNumber'
 *      incomingEmailAddress: // value for 'incomingEmailAddress'
 *      senderEmailAddress: // value for 'senderEmailAddress'
 *      password: // value for 'password'
 *      notifyUnsuccessfulReceiving: // value for 'notifyUnsuccessfulReceiving'
 *      additionalFaxSendingEmails: // value for 'additionalFaxSendingEmails'
 *   },
 * });
 */
export function useUpdateFaxMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFaxMutation, UpdateFaxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFaxMutation, UpdateFaxMutationVariables>(UpdateFaxDocument, options);
      }
export type UpdateFaxMutationHookResult = ReturnType<typeof useUpdateFaxMutation>;
export type UpdateFaxMutationResult = Apollo.MutationResult<UpdateFaxMutation>;
export type UpdateFaxMutationOptions = Apollo.BaseMutationOptions<UpdateFaxMutation, UpdateFaxMutationVariables>;
export const SynchronizeFaxDocument = gql`
    mutation SynchronizeFax($domainId: Int!) {
  synchronizeFax(domainId: $domainId) {
    created
    updated
    deleted
    errors {
      location
      context
      type
    }
  }
}
    `;
export type SynchronizeFaxMutationFn = Apollo.MutationFunction<SynchronizeFaxMutation, SynchronizeFaxMutationVariables>;

/**
 * __useSynchronizeFaxMutation__
 *
 * To run a mutation, you first call `useSynchronizeFaxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSynchronizeFaxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [synchronizeFaxMutation, { data, loading, error }] = useSynchronizeFaxMutation({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useSynchronizeFaxMutation(baseOptions?: Apollo.MutationHookOptions<SynchronizeFaxMutation, SynchronizeFaxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SynchronizeFaxMutation, SynchronizeFaxMutationVariables>(SynchronizeFaxDocument, options);
      }
export type SynchronizeFaxMutationHookResult = ReturnType<typeof useSynchronizeFaxMutation>;
export type SynchronizeFaxMutationResult = Apollo.MutationResult<SynchronizeFaxMutation>;
export type SynchronizeFaxMutationOptions = Apollo.BaseMutationOptions<SynchronizeFaxMutation, SynchronizeFaxMutationVariables>;